export const BNK_STMT_updateNoOfMonthsToShowReducer = {
  BNK_STMT_updateNoOfMonthsToShow: (state, action) => {
    state.noOfMonthsToShow = parseInt(action.payload);
  },
};
